import { render, staticRenderFns } from "./ChatBotCreditLow.vue?vue&type=template&id=5e305911&scoped=true"
import script from "./ChatBotCreditLow.vue?vue&type=script&lang=js"
export * from "./ChatBotCreditLow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e305911",
  null
  
)

export default component.exports